
import * as React from 'react';
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import back_arrow from "../../images/back_arrow.png";
import { useMediaQuery } from "react-responsive";
import "./OTPVerificationForm.css";
import { useAppSelector } from '../../store/hooks';

interface Props {
    code: string[];
    userInput: string;
    error: string;
    isInvalid: boolean;
    isNewOtp: boolean;
    enableSubmit: boolean;
    onBack: () => void;
    onChange: (index: number, value: string) => void;
    onPaste: (index: number, e: React.ClipboardEvent<HTMLInputElement>) => void;
    onSubmit: () => void;
    onResend: () => void;
    setCode: (code: string[]) => void;
    isSubmitting?: boolean;
}

const OTPVerificationForm: React.FC<Props> = ({
                                                  code,
                                                  userInput,
                                                  isInvalid,
                                                  isNewOtp,
                                                  enableSubmit,
                                                  onBack,
                                                  onChange,
                                                  onPaste,
                                                  onSubmit,
                                                  onResend,
                                                  setCode,
                                                  isSubmitting = false,
                                              }) => {
    const isDesktopOrLaptop = useMediaQuery({ query: "(min-width: 768px)" });

    const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Backspace") {
            if (code[index] === "" && index > 0) {
                document.getElementById(`code-${index - 1}`)?.focus();
            } else {
                const newCode = [...code];
                newCode[index] = "";
                setCode(newCode);
            }
        }
        if (e.key === "ArrowLeft" && index > 0) {
            document.getElementById(`code-${index - 1}`)?.focus();
        }
        if (e.key === "ArrowRight" && index < code.length - 1) {
            document.getElementById(`code-${index + 1}`)?.focus();
        }
        if (e.key === "Enter" && code.every((c) => c !== "")) {
            onSubmit();
        }
    };

    const handleChange = (index: number, value: string) => {
        if (/^\d?$/.test(value)) {
            const newCode = [...code];
            newCode[index] = value;
            setCode(newCode);
            onChange(index, value);

            if (value !== "" && index < code.length - 1) {
                const next = document.getElementById(`code-${index + 1}`);
                next?.focus();
            }
        }
    };
    const isPhoneNumberEnter = useAppSelector(({ search }) => search.isPhoneNumberEnter);

    return (
        <div className="conciergeLogin-verify">
            <div className="back-button" onClick={onBack}>
                <div style={{ display: "flex", gap: "10px", alignItems: "center", fontWeight: 600 }}>
                    <img src={back_arrow} alt="Back" className="back-arrow" />
                    Back
                </div>
            </div>
            <Card className="shadow-sm p-4" style={{ width: isDesktopOrLaptop ? "26.125rem" : "23.125rem" }}>
                <Card.Body>
                    <Card.Title className="text-center" style={{ marginBottom: "36px", fontSize: isDesktopOrLaptop ? "17px" : "15px" }}>
                        <div style={{ color: "#0A4DB2", fontWeight: 600 }}>Please enter verification code sent to</div>
                        <div style={{ color: "#178188" }}>{userInput}</div>
                    </Card.Title>
                    <Row className="mb-3 justify-content-center gx-1">
                        {code.map((digit, index) => (
                            <Col key={index}>
                                <Form.Control
                                    id={`code-${index}`}
                                    type="text"
                                    maxLength={1}
                                    value={digit}
                                    className="text-center"
                                    autoFocus={index === 0}
                                    onChange={(e) => handleChange(index, e.target.value)}
                                    onPaste={(e) => onPaste(index, e as React.ClipboardEvent<HTMLInputElement>)}
                                    onKeyDown={(e) => handleKeyDown(index, e as React.KeyboardEvent<HTMLInputElement>)}
                                    style={{ minWidth: "15px", fontSize: "1.85rem" }}
                                />
                            </Col>
                        ))}
                    </Row>

                    <div className="text-center invalidOTP" style={{ visibility: isInvalid ? "visible" : "hidden" }}>
                        Invalid one-time password.
                    </div>

                    {isNewOtp && (
                        <div className="text-center resendOTP" style={{ fontWeight: "bold", fontSize: isDesktopOrLaptop ? "0.9rem" : "0.7rem" }}>
                            {`A new one-time code was sent to your ${isPhoneNumberEnter ? 'phone': 'email'}`}.
                        </div>
                    )}

                    <button
                        className={`${enableSubmit ? "button-container" : "white-button"} w-100`}
                        disabled={isSubmitting}
                        style={{ marginTop: "20px", height: "3rem" }}
                        onClick={onSubmit}
                    >
                        {isSubmitting ? "Please wait..." : "Login"}
                    </button>
                    <button
                        className="blue-button w-100"
                        style={{ marginTop: "20px", fontWeight: "bold", height: "3rem" }}
                        onClick={onResend}
                    >
                        Resend code
                    </button>
                </Card.Body>
            </Card>
        </div>
    );
};

export default OTPVerificationForm;